export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  border: true,
  hover: 'light-7',
  fontSize: '3',
  fareBodyItem: {
    textColor: 'dark',
    padding: '2',
    grow: '2',
  },
  fareFooterItem: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHeight: '2',
    bgColor: 'primary',
    textColor: 'white',
    grow: '1',
    roundedRight: '@theme:card.rounded',
  },
  showOriginDestinationImage: false,
  showRoute: false,
  showDepartureInfo: true,
  showReturnInfo: false,
  showJourneyType: true,
  showTravelClass: true,
  showPrice: true,
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showSeparator: true,
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'uppercase',
    marginBottom: '3',
    style: { lineHeight: '1' },
  },
  separatorJourneyTypeProps: {
    content: '|',
  },
  fareItemJourneyType: {},
  fareItemTravelClass: {},
  fareItemRoute: {},
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    fontWeight: 'bold',
    textAlign: 'center',
    paddingBottom: '1',
    pricePromoStyles: {
      fontWeight: 'bold',
    },
    currencyStyles: {
      fontSize: '5',
    },
  },
};
